import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { DynamicComponentDirective, MenuContentItem } from '@frontend/vanilla/core';
import { ButtonStyle, HeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { ProductMenuConfig } from '@frontend/vanilla/shared/product-menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ProductMenuService } from '../product-menu.service';
import { ProductMenuItemBase } from './product-menu-item-base';

@Component({
    imports: [HeaderBarComponent, DynamicComponentDirective],
    selector: 'vn-pm-header-bar',
    templateUrl: 'header-bar.html',
})
export class ProductMenuHeaderBarComponent extends ProductMenuItemBase implements OnInit, OnDestroy {
    config = inject(ProductMenuConfig);
    localProductMenuService = inject(ProductMenuService);

    title: string;
    headerLogoItem: boolean;
    private unsubscribe = new Subject();
    closeDsButtonStyling: ButtonStyle;

    ngOnInit() {
        this.productMenuService.currentTab.pipe(takeUntil(this.unsubscribe)).subscribe((menuItem: MenuContentItem | null) => {
            this.title = menuItem?.text || this.item.text;
        });

        const bodyMenu = this.config.menu?.children?.find((item) => item.name === 'body');
        const headerBarMenu = bodyMenu?.children?.find((item) => item.type === 'header' || item.name === 'headerbar');

        if (headerBarMenu?.children?.length) {
            this.headerLogoItem = true;
        }
        if (headerBarMenu) {
            this.closeDsButtonStyling = {
                variant: (headerBarMenu?.resources['variant'] as 'filled' | 'outline' | 'flat' | 'flat-reduced') ?? 'outline',
                kind: (headerBarMenu?.resources['kind'] as 'primary' | 'secondary' | 'tertiary' | 'success' | 'utility') ?? 'secondary',
                size: (headerBarMenu?.resources['size'] as 'small' | 'medium' | 'large') ?? 'medium',
                inverse: Boolean(headerBarMenu?.resources['inverse']),
            };
        }
    }

    ngOnDestroy() {
        this.unsubscribe.next(null);
        this.unsubscribe.complete();
    }
}
